const setSlidesInView = () => {
	window.logoSlidesInView = 2;
	if (window.matchMedia(`(min-width: ${gridBreakpoints.sm}px)`).matches) {
		window.logoSlidesInView = 3;
	}
	if (window.matchMedia(`(min-width: ${gridBreakpoints.md}px)`).matches) {
		window.logoSlidesInView = 5;
	}
	if (window.matchMedia(`(min-width: ${gridBreakpoints.lg}px)`).matches) {
		window.logoSlidesInView = 6;
	}
};

setSlidesInView();
window.addEventListener('resize', () => {
	setSlidesInView();
});

document.querySelectorAll('.block-logo-slider').forEach((slider) => {
	const slideCount = slider.querySelectorAll('.block-logo-slider__slide').length;

	setInterval(() => {
		// Get slide we want to change.
		const currentSlideNum = Math.ceil(Math.random() * window.logoSlidesInView);
		const currentSlide = slider.querySelector(
			`.block-logo-slider__slide:nth-child(${currentSlideNum})`
		);

		// Get replacement slide.
		const nextSlideNum =
			window.logoSlidesInView -
			1 +
			Math.ceil(Math.random() * (slideCount - window.logoSlidesInView));
		const nextSlide = slider.querySelector(
			`.block-logo-slider__slide:nth-child(${nextSlideNum})`
		);

		if (!currentSlide || !nextSlide) {
			return;
		}

		const currentSlideHtml = currentSlide?.innerHTML;
		const nextSlideHtml = nextSlide?.innerHTML;

		currentSlide.classList.add('fade-out');
		setTimeout(() => {
			currentSlide.innerHTML = nextSlideHtml;
			nextSlide.innerHTML = currentSlideHtml;
			currentSlide.classList.remove('fade-out');
		}, 300);
	}, 3000);
});
